<template>
  <div class="info" data-element="Info">
    <div v-if="image" class="info-media">
      <ElementsImage v-bind="image" />
    </div>
    <div class="info-content">
      <slot>
        <div v-if="title || $slots.title" class="info-content__title">
          <slot name="title">{{ title }}</slot>
        </div>
        <div v-if="description || $slots.description" class="info-content__description">
          <slot name="description">{{ description }}</slot>
        </div>
        <div v-if="button || $slots.button">
          <slot name="cta">
            <a v-if="button" :href="button.href" class="info-content__link">
              {{ button.title }}
            </a>
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    image?: any
    title?: string
    description?: string
    button?: {
      href: string
      title: string
    }
  }>()
</script>

<style lang="scss" scoped>
  .info {
    @apply flex overflow-hidden;

    &-media {
      @apply w-138 min-h-76 flex-none;
      background: #f2f0e9;

      :deep(img) {
        @apply w-full h-full object-cover;
      }
    }
    &-content {
      @apply flex flex-col justify-center px-16 py-8 gap-6;

      &__title {
        @apply font-display uppercase text-2xl font-semibold;
        color: #000;
        letter-spacing: 0.1em;
      }
      &__description {
        @apply text-lg;
        color: #555;
      }
      &__link {
        @apply text-sm leading-6 font-bold uppercase underline w-fit pt-1;
        color: #282828;
        letter-spacing: 0.15em;
        text-underline-offset: 5px;
      }
    }

    @include media("xl") {
      &-media {
        @apply w-120 min-h-40;
      }
      &-content {
        @apply pl-12 pr-6 py-6 gap-4;

        &__title {
          @apply text-xl;
        }
        &__description {
          @apply text-base;
        }
      }
    }
    @include media("lg") {
      @apply flex-col gap-6;

      &-media {
        @apply w-full min-h-none;
      }
      &-content {
        @apply p-0 gap-2;

        &__title {
          @apply text-lg;
        }
        &__description {
          @apply text-base;
        }
      }
    }
    @include media("md") {
      @apply gap-4;

      &-content {
        @apply gap-1.5;

        &__title {
          @apply text-base;
        }
        &__description {
          @apply text-sm;
        }
        &__link {
          @apply text-xs leading-5;
          text-underline-offset: 4px;
        }
      }
    }
  }
</style>
